import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { usersClient } from "@core/clients";
import { RemoveUserResponse } from "@core/types";

type Options = UseMutationOptions<RemoveUserResponse | null, any>;

const useDeleteMeMutation = (options?: Options) => {
  return useMutation(
    ["delete-profile"],
    async () => {
      return await usersClient.deleteMe();
    },
    { ...options }
  );
};

export default useDeleteMeMutation;
